export const reasonToDeclineReferredQuote = ['Underwriting Issues'];

export const reasonsToDeclineAllQuotes = [
  'Class Ineligible',
  'Loss History',
  'Lead Time Insufficient',
  'Capacity',
  'Other',
];

export const lossTypes = ['Loss Severity', 'Loss Frequency'];

export const capacityTypes = ['Insufficient Property Limits', 'Insufficient Casualty Limits'];
